import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * Control hook for configuring the Tiles layout for an item set.
 */
export const tilesLayoutControl = new ControlFacet<{}, {
  isAvailable: boolean;
  /**
   * An override for the item set key to use for rendering the content for the
   * layout.
   */
  itemKey: string;
}>('tilesLayoutControl');
